module.exports = __webpack_public_path__ + "static/img/double-sign-in-bg.fd39123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-sign-in/double-sign-in-bg.png
// module id = AV6b
// module chunks = 213